import React, { useContext } from 'react';

import Alert from '@amzn/meridian/alert';
import Toaster from '@amzn/meridian/toaster';

import { AppContext } from 'src/contexts/appContext';

export const ToasterWrapper = () => {
    const { toasts, setToasts } = useContext(AppContext);

    return (
        <Toaster toasts={toasts} onCloseToast={() => setToasts([])}>
            {(toast) => (
                <Alert
                    toast={true}
                    type={toast.type || 'success'}
                    size="large"
                    onClose={() => setToasts((prev) => prev.filter((t) => t.id !== toast.id))}
                >
                    {toast.message}
                </Alert>
            )}
        </Toaster>
    );
};
